import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import MUIDataTable from "mui-datatables";
import CloseIcon from '@material-ui/icons/Close';
import firebase from '../firebase'
import 'firebase/firebase-firestore'
import 'firebase/storage';
import { CircularProgress, Button } from '@material-ui/core'
import Avatar from '@material-ui/core/Avatar';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function Students(props) {
	const baseURL = process.env.PUBLIC_URL;
	const [students, setStudents] = useState([])
	const [description, setDescription] = useState(false)
	const [dataStudent, setDataStudent] = useState([])

	const openDescription = (data) => {
		if(!description){
			setDataStudent(data);
		} else{
			setDataStudent([])
		}
		setDescription(!description);
	  };

	const close = ()=>{
		props.history.replace(baseURL+'/dashboard')
	}
	/*address: "Las rozas de madrid"
belt: "blue"
email: "gabrielalejandroqd@gmail.com"
height: "1.9"
lastname: "Quintero"
name: "Gabriel"
nick: "Gabo"
phone: "658403905"
pic: "https://firebasestorage.googleapis.com/v0/b/aforo-bjj.appspot.com/o/pictures_profile%2F1bRyfQffnpYyrtOq4FDe94EK1Iu2.jpg?alt=media&token=a5f8393a-b4f2-4a24-938a-7bb4ac1db05d"
strips: "3"
uuid: "1bRyfQffnpYyrtOq4FDe94EK1Iu2"
weight: "106"*/

	// table options
	const columns = [
		{
		 name: "pic",
		 label: " ",
		 options: {
		  filter: true,
		  sort: true, 
		  customBodyRender: (value) => {
			return (
				<Avatar className="avatar" src={value} />
			);
		  },
		 }
		},
		{
			name: "lastname",
			options: {
				display: 'excluded'
			  }
		},
		{
		 name: "name",
		 label: "Nombre",
		 options: {
		  filter: true,
		  sort: true,
		  customBodyRender: (value, tableMeta, updateValue) => {
			return (
				<span onClick={()=>{openDescription(tableMeta.rowData)}}>{tableMeta.rowData[1] ? value + ' ' +tableMeta.rowData[1] : value}</span>
			);
		  },
		 }
		},
		{
		 name: "belt",
		 label: "Cinturon",
		 options: {
		  filter: true,
		  sort: true,
		  customBodyRender: (value) => {
			return (
				<div className={'beltList '+value} ></div>
			);
		  },
		 }
		},
		{
			name: "email",
			label: "Email",
			options: {
				filter: true,
				sort: true,
				display: 'false'
			  }
		},
		{
			name: "phone",
			label: "Teléfono",
			options: {
				filter: true,
				sort: true,
				display: 'false'
			  }
		},
		{
			name: "weight",
			label: "Peso Kg",
			options: {
				filter: true,
				sort: true,
				display: 'false'
			  }
		},
		{
			name: "height",
			label: "Estatura",
			options: {
				filter: true,
				sort: true,
				display: 'false'
			  }
		},
		{
			name: "address",
			label: "Dirección",
			options: {
				filter: true,
				sort: true,
				display: 'false'
			  }
		}
	   ];

		const options = {
			selectableRows:false,
			responsive:'standard',
			rowsPerPage:500,
			pagination: false
		};

	useEffect (()=> {
		if(localStorage.getItem('studentList')){
			console.log('hay datos')
			setStudents(JSON.parse(localStorage.getItem('studentList')))
		}else{
			const data = firebase.db.collection('students')
			.onSnapshot(query => {
				const studentList = query.docs.map(item => item.data())
				setStudents(studentList)
				localStorage.setItem('studentList', JSON.stringify(studentList));
				console.log('no hay y se cargan datos')
			})
		}

	},[]);

	return (
		<main>
			<header className="header-aux">
				<div></div>
				<h3>Alumnos</h3>
				<CloseIcon onClick={close} />
			</header>
			<section className="container">
				{students.length > 0 
				?
				<> 
					<MUIDataTable
					data={students}
					columns={columns}
					options={options}
				/>
					<Dialog
					open={description}
					onClose={openDescription}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">{dataStudent[1] ? dataStudent[2] +' '+ dataStudent[1] : dataStudent[2]}</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-description">
						<div><strong>Teléfono: </strong>{dataStudent[5]}</div>
						<div><strong>Email: </strong>{dataStudent[4]}</div>
						<div><strong>Peso: </strong>{dataStudent[6]}</div>
						<div><strong>Estatura: </strong>{dataStudent[7]}</div>
						<div><strong>Dirección: </strong>{dataStudent[8]}</div>
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					</DialogActions>
				</Dialog>
				</>
				:
				<div className="loading">
					<CircularProgress />
				</div>
				}
			</section>
		</main>
	)
}

export default withRouter(Students)